<script setup lang="ts">
import { NuxtLink } from '#components'

withDefaults(defineProps<{
  link?: boolean
}>(), {
  link: true,
})
</script>

<template>
  <component
    :is="link ? NuxtLink : 'div'"
    :to="link ? '/' : undefined"
    class="ics-t41zno"
  >
    <span
      v-if="link"
      class="sr-only"
    >Home</span>
    <svg viewBox="0 0 864.344 260.741">
      <g
        id="text"
        class="transition-fill fill-icsblue dark:fill-icscyan"
      >
        <path d="M313.408 67.277h39.349v157.871h-39.349z" />
        <path d="M404.025 67.277c-9.211 0-17.853 3.569-24.334 10.05s-10.05 15.123-10.05 24.334v89.101c0 9.211 3.569 17.853 10.05 24.334s15.123 10.05 24.334 10.05H527.09v-39.349H408.779v-79.172H527.09v-39.35H404.025Z" />
        <path d="M663.63 67.277h-89.101c-9.211 0-17.853 3.569-24.334 10.05s-10.05 15.123-10.05 24.334v30.87c0 8.566 3.569 16.604 10.05 22.631s15.123 9.347 24.334 9.347h84.911v22.274h-81.142v-11.47h-38.154v15.45c0 9.211 3.569 17.853 10.05 24.334s15.123 10.05 24.334 10.05h89.101c18.96 0 34.385-15.425 34.385-34.385v-30.87c0-17.633-15.425-31.978-34.385-31.978h-85.331v-22.273h81.142v11.47h38.574v-15.45c0-18.96-15.425-34.385-34.385-34.385Z" />
      </g>
      <path
        id="cable"
        class="fill-none stroke-10 stroke-icsred"
        d="M752.279 245.804H272.96a18 18 0 0 1-13.909-6.575l-51.365-62.531c-3.06-3.725-8.37-4.002-11.801-.616l-57.023 56.279c-7.491 7.393-13.62 4.831-13.62-5.694V163.45c0-10.525-6.129-13.087-13.62-5.694l-89.677 88.617c-4.172 4.118-10.982 3.756-14.694-.78a9.95 9.95 0 0 1 .711-13.387L152.826 89.123c3.431-3.386 8.742-3.109 11.801.616L272.565 221.14c4.054 4.935 11.471 5.322 16.017.836a10.857 10.857 0 0 0 .763-14.619l-69.312-84.378c-2.549-3.103-2.296-7.951.562-10.772L326.814 7.374c3.448-3.403 8.769-3.112 11.826.646l35.109 43.165"
      />
      <path
        id="connector"
        class="fill-icsred"
        d="M864.344 233.526h-19.613v-.363a2.295 2.295 0 0 0-2.296-2.295H798.16a2.296 2.296 0 0 0-2.296 2.295v.363h-18.386l-3.837 1.955h-13.492a2.89 2.89 0 0 0-2.891 2.892v14.863a2.89 2.89 0 0 0 2.891 2.892h13.492l3.837 1.955h18.386v.363a2.295 2.295 0 0 0 2.296 2.295h44.275a2.296 2.296 0 0 0 2.296-2.295v-.363h19.613v-24.556Z"
      />
    </svg>
    <slot />
  </component>
</template>
